// extracted by mini-css-extract-plugin
export var boxItems = "_2a-1";
export var boxItemsLg = "_2a-2";
export var button = "_2a-7";
export var buttonHoverless = "_2a-9";
export var buttonLg = "_2a-8";
export var filterGroupBox = "_2a-0";
export var icon = "_2a-3";
export var iconSecondary = "_2a-6";
export var iconWrapper = "_2a-4";
export var iconWrapperLg = "_2a-5";
export var truncatedLabel = "_2a-a";